import * as React from 'react';

import { CarouselAsset as CarouselAssetType } from './types';
import CarouselModal from './CarouselModal';
import CarouselImage from './CarouselImage';
import CarouselMap from './CarouselMap';

interface CarouselProps {
  carouselAssets: CarouselAssetType[];
  buttons?: React.ReactNode;
  showMobile?: boolean;
}

interface CarouselState {
  selectedIndex: number;
  panning: boolean;
  hideLeft: boolean;
  hideRight: boolean;
}

const CarouselAsset: React.FunctionComponent<{ asset: CarouselAssetType }> = ({
  asset,
}) => {
  if (asset.type === 'map') return <CarouselMap address={asset.address} />;
  if (asset.type === 'image') return <CarouselImage src={asset.url} />;
  return null;
};

class Carousel extends React.Component<CarouselProps, CarouselState> {
  carouselContainerId: string;

  mainAsset: CarouselAssetType;

  firstHalfAssets: CarouselAssetType[];

  secondHalfAssets: CarouselAssetType[];

  constructor(props: CarouselProps) {
    super(props);

    const { carouselAssets } = this.props;

    this.carouselContainerId = 'asset-carousel-container';

    let restAssets;
    [this.mainAsset, ...restAssets] = carouselAssets;
    this.firstHalfAssets = restAssets.slice(
      0,
      Math.ceil(restAssets.length / 2),
    );
    this.secondHalfAssets = restAssets.slice(
      Math.ceil(restAssets.length / 2),
      restAssets.length,
    );

    this.state = {
      selectedIndex: -1,
      panning: false,
      hideLeft: true,
      hideRight: false,
    };
  }

  async componentDidMount() {
    if (
      $(`#${this.carouselContainerId}`)[0] === undefined &&
      $(`#xs-${this.carouselContainerId}`)?.[0] === undefined
    ) {
      return;
    }

    if (
      $(`#${this.carouselContainerId}`)[0].scrollWidth === 0 &&
      $(`#xs-${this.carouselContainerId}`)?.[0]?.scrollWidth === 0
    ) {
      return;
    }

    this.setState({
      hideLeft: !this.canScrollLeft(),
      hideRight: !this.canScrollRight(),
    });
  }

  canScrollRight = () => (
      $(`#${this.carouselContainerId}`).scrollLeft() <
        $(`#${this.carouselContainerId}`)[0].scrollWidth -
          $(`#${this.carouselContainerId}`).width() ||
      $(`#xs-${this.carouselContainerId}`)?.scrollLeft() <
        $(`#xs-${this.carouselContainerId}`)[0]?.scrollWidth -
          $(`#xs-${this.carouselContainerId}`)?.width()
    );

  canScrollLeft = () => (
      $(`#${this.carouselContainerId}`).scrollLeft() > 0 ||
      $(`#xs-${this.carouselContainerId}`)?.scrollLeft() > 0
    );

  panRight = () => {
    const { panning } = this.state;

    const half = $(`#${this.carouselContainerId}`).width() / 2;
    const assetSize = $(`#xs-${this.carouselContainerId}`)?.width();

    if (this.canScrollRight() && !panning) {
      this.setState({
        panning: true,
      });

      $(`#${this.carouselContainerId}`).animate(
        { scrollLeft: `+=${half}` },
        500,
        'easeOutQuart',
        () => {
          this.setState({
            panning: false,
            hideLeft: !this.canScrollLeft(),
            hideRight: !this.canScrollRight(),
          });
        },
      );

      $(`#xs-${this.carouselContainerId}`).animate(
        { scrollLeft: `+=${assetSize}` },
        500,
        'easeOutQuart',
        () => {
          this.setState({
            panning: false,
            hideLeft: !this.canScrollLeft(),
            hideRight: !this.canScrollRight(),
          });
        },
      );
    } else {
      this.setState({
        hideLeft: !this.canScrollLeft(),
        hideRight: !this.canScrollRight(),
      });
    }
  };

  panLeft = () => {
    const { panning } = this.state;

    const half = $(`#${this.carouselContainerId}`).width() / 2;
    const assetSize = $(`#xs-${this.carouselContainerId}`).width();
    if (this.canScrollLeft() && !panning) {
      this.setState({
        panning: true,
      });
      $(`#${this.carouselContainerId}`).animate(
        { scrollLeft: `-=${half}` },
        500,
        'easeOutQuart',
        () => {
          this.setState({
            panning: false,
            hideLeft: !this.canScrollLeft(),
            hideRight: !this.canScrollRight(),
          });
        },
      );
      $(`#xs-${this.carouselContainerId}`).animate(
        { scrollLeft: `-=${assetSize}` },
        500,
        'easeOutQuart',
        () => {
          this.setState({
            panning: false,
            hideLeft: !this.canScrollLeft(),
            hideRight: !this.canScrollRight(),
          });
        },
      );
    }
  };

  openModal = (index: number) => {
    this.setState({ selectedIndex: index });
  };

  render() {
    const { selectedIndex, hideLeft, hideRight } = this.state;
    const { carouselAssets, buttons, showMobile = true } = this.props;

    return (
      <>
        <div className="carousel-btn-container">
          <div
            onClick={this.panLeft}
            className={`carousel-left carousel-btn${
              hideLeft ? ' opacity-0' : ''
            }`}
          >
            <i className="fa fa-angle-double-left"></i>
          </div>
          <div
            onClick={this.panRight}
            className={`carousel-left carousel-btn${
              hideRight ? ' opacity-0' : ''
            }`}
          >
            <i className="fa fa-angle-double-right"></i>
          </div>
        </div>
        {buttons}
        <div
          id={this.carouselContainerId}
          className="assets-carousel hidden-xs"
        >
          <div
            style={{ height: '100%', width: '50%' }}
            onClick={() => this.openModal(0)}
          >
            <CarouselAsset asset={this.mainAsset} />
          </div>
          <div style={{ height: '100%', width: '50%' }}>
            <div className="carousel-row">
              {this.firstHalfAssets.map((asset, index) => (
                <div
                  key={index}
                  className="carousel-item"
                  onClick={() => this.openModal(index + 1)}
                >
                  <CarouselAsset asset={asset} />
                </div>
              ))}
            </div>
            <div className="carousel-row">
              {this.secondHalfAssets.map((asset, index) => (
                <div
                  key={index}
                  className="carousel-item"
                  onClick={() =>
                    this.openModal(this.firstHalfAssets.length + index + 1)
                  }
                >
                  <CarouselAsset asset={asset} />
                </div>
              ))}
            </div>
          </div>
        </div>
        {showMobile && (
          <div className="visible-xs">
            <div
              id={`xs-${this.carouselContainerId}`}
              className="mobile-carousel"
            >
              {carouselAssets.map((asset, index) => (
                <div
                  key={index}
                  style={{ flex: '0 0 auto', height: '100%', width: '100%' }}
                >
                  <CarouselAsset asset={asset} />
                </div>
              ))}
            </div>
          </div>
        )}
        {selectedIndex > -1 && (
          <CarouselModal
            carouselAssets={carouselAssets}
            closeModal={() => this.setState({ selectedIndex: -1 })}
            startIndex={selectedIndex}
          />
        )}
      </>
    );
  }
}

export default Carousel;
